import React from "react";
import "./Projects.css";

const projects = [
  {
    title: "IPL Score Prediction",
    description: "Machine Learning project that predicts IPL match scores using regression algorithms.",
    image: "/images/ipl.jpg",
    github: "https://github.com/Vivekchary2607/IPL_SCORE_PREDICTION_PROJECT_USING_MACHINE_LEARNING.gith",
    
  },
  {
    title: "Student Performance Predictor",
    description: "A Streamlit app that predicts student pass/fail outcomes using Random Forest.",
    image: "/images/student.jpg",
    github: "https://github.com/Vivekchary2607/AI-Powered-EduPredict-Student-Performance-Analytics-System.git",
    
  },
  {
    title: "Superstore Sales Analysis",
    description: "SQL-based data analysis project exploring key business insights from sales data.",
    image: "/images/sales.png",
    github: "https://github.com/Vivekchary2607/Superstore_Sales_Analysis.git",
    
  },
];

function Projects() {
  return (
    <section id="projects" className="projects-section">
      <h2>My Projects</h2>
      <div className="projects-grid">
        {projects.map((project, index) => (
          <div className="project-card" key={index}>
            <img src={project.image} alt={project.title} />
            <div className="content">
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <div className="project-links">
                <a href={project.github} target="_blank" rel="noreferrer">View Project</a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Projects;
